import { Loan, PageProgress } from '../../openapi-ts';
import PurposeEnum = Loan.PurposeEnum;

export function translateLoanPurpose(value: PurposeEnum): string {
  switch (value) {
    case PurposeEnum.NewCar:
      return 'Neufahrzeug';
    case PurposeEnum.UsedCar:
      return 'Gebrauchtfahrzeug';
    case PurposeEnum.Furniture:
      return 'Einrichtung/Möbel';
    case PurposeEnum.DebtConversion:
      return 'Umschuldung/Kredit ablösen';
    case PurposeEnum.Modernization:
      return 'Modernisierung/Baufinanzierung';
    case PurposeEnum.Electronics:
      return 'PC/Audio/Video';
    case PurposeEnum.Journey:
      return 'Reise';
    case PurposeEnum.Other:
      return 'Freie Verwendung';
    case PurposeEnum.Dispo:
      return 'Ausgleich Dispo';
    case PurposeEnum.Motorbike:
      return 'Motorrad';
    case PurposeEnum.Ballon:
      return 'Kredit mit Schlussrate';
    default:
      return '-';
  }
}

export function translatePageProgressName(value: string): string {
  switch (value) {
    case 'KREDIT_INSURANCE':
      return 'Kreditschutz';
    case 'TERMS_AND_CONDITIONS':
      return 'Bedingungen';
    case 'IDENT':
    case 'QES':
      return 'Videotelefonie';
    case 'UPLOAD':
      return 'Dokumente';
    case 'SUMMARY':
      return 'Auszahlung';
    case 'CLICKOUT':
      return 'Weiterleitung';
    case 'EXPIRED':
      return 'Abgelaufen';
    case 'REJECTED':
      return 'Abgelehnt';
  }
}
